import FloatingActionButton from './FloatingActionButton.vue'

export { FloatingActionButton }
export default FloatingActionButton
